import React, {Component} from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
import * as PropTypes from "prop-types";
import classNames from 'classnames';
import css from 'dom-css';
import '../../../assets/sass/global/scrollbars/shadow-scrollbars.scss';
import LoadingOverlay from "../feedback/LoadingOverlay";

class ShadowScrollbars extends Component {
    /**
     * ShadowScrollbars constrictor.
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            scrollTop: 0,
            scrollHeight: 0,
            clientHeight: 0
        };

        this.handleUpdate = this.handleUpdate.bind(this);
    }

    /**
     * Updates position and shadows of the scrollbar track.
     * @param values {object}
     * @listens Scrollbars:onUpdate
     */
    handleUpdate = (values) => {
        const {shadowTop, shadowBottom} = this.refs;
        const {scrollTop, scrollHeight, clientHeight} = values;
        const shadowTopOpacity = 1 / 20 * Math.min(scrollTop, 20);
        const bottomScrollTop = scrollHeight - clientHeight;
        const shadowBottomOpacity = 1 / 20 * (bottomScrollTop - Math.max(scrollTop, bottomScrollTop - 20));
        css(shadowTop, {opacity: shadowTopOpacity});
        css(shadowBottom, {opacity: shadowBottomOpacity});

        const {onEndReached} = this.props;
        if (typeof onEndReached === 'function' && (bottomScrollTop > 0) && (bottomScrollTop - scrollTop < 1)) {
            onEndReached();
        }
    };

    /**
     * Renders the component witch wrapped within scrollbar.
     * @returns {React.ReactNode}
     */
    render = () => {
        const {style, direction, withPadding, loading, ...props} = this.props;

        return (
            <div className={classNames("shadow-scrollbar", `shadow-scrollbar--${direction}`, withPadding ? 'with-padding' : '')}>
                <div className="inner-scrollbar">
                    <Scrollbars
                        ref="scrollbars"
                        renderTrackVertical={this.renderTrackVertical}
                        renderTrackHorizontal={this.renderTrackHorizontal}
                        renderView={this.renderView}
                        onUpdate={this.handleUpdate}
                        autoHide
                        {...props}>
                        {this.renderContent()}
                    </Scrollbars>
                    {/*{this.renderContent()}*/}
                    <div ref="shadowTop" className="shadow-top"/>
                    <div ref="shadowBottom" className="shadow-bottom"/>
                </div>
                {loading && <LoadingOverlay/>}
            </div>
        );
    };

    renderTrackVertical = props => {
        return (<div {...props} className="shadow-scrollbar--track-vertical"/>);
    };

    renderTrackHorizontal = props => {
        return (<div {...props} className="shadow-scrollbar--track-horizontal"/>);
    };

    renderView = props => {
        return (<div className="shadow-scrollbar--view"/>);
    };

    renderContent = props => {
        return (<div className="shadow-scrollbar--content"> {this.props.children} </div>);
    };

    static propTypes = {
        style: PropTypes.object,
        direction: PropTypes.oneOf(['left', 'right']),
        onEndReached: PropTypes.func,
    };

    static defaultProps = {
        direction: 'right',
    };
}

/**
 * Wraps the content within scrollbar.
 * @param component {React.ReactNode} The component witch wrapped within scrollbar..
 * @returns {React.ReactNode} The wrapped component.
 */
ShadowScrollbars.wrap = component => <ShadowScrollbars> {component} </ShadowScrollbars>;
ShadowScrollbars.wrapWithPadding = component => <ShadowScrollbars withPadding> {component} </ShadowScrollbars>;
ShadowScrollbars.defaultOptions = [10, 20, 30, 50].map(item => {
    return {value: item, label: item}
});
ShadowScrollbars.defaultOption = ShadowScrollbars.defaultOptions[0];

export default ShadowScrollbars;
